<template>
  <div>
    <v-layout row wrap>
      <v-flex md6 pr-4>
        <v-select
          v-model="filters.channel"
          :items="channels"
          color="grey">
        </v-select>
      </v-flex>
      <v-flex md6 pl-4>
        <v-select
          v-model="filters.portfolio_type"
          :items="pursesList"
          color="grey">
        </v-select>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex md12>
        <v-select
          v-model="filters.tranche"
          :items="trMorasList"
          color="grey">
        </v-select>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import reportsListMixin from '@/mixins/reportsList';
import EventBus from '@/event-bus';

export default {
  mixins: [
    reportsListMixin,
  ],
  created() {
    EventBus.$on('applyDetailedFilters', () => {
      EventBus.$emit('filterDetailedGraphic', this.filters);
    });
  },
  destroyed() {
    EventBus.$off('applyDetailedFilters');
  },
  data() {
    return {
      channels: [
        {
          value: 'email',
          text: 'Email',
        },
        {
          value: 'sms',
          text: 'Sms',
        },
        {
          value: 'ivr',
          text: 'Ivr',
        },
        {
          value: 'bot',
          text: 'Bot',
        },
      ],
      filters: {
        channel: 'email',
        tranche: '',
        portfolio_type: '',
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/panel/management/filters/Detailed.vue